import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "./RootLayout";
import { HomePage } from "../modules/home/pages/HomePage";
import { JobDetails } from "../modules/jobs/pages/JobDetails";
import { PageBaseLayout } from "../layouts/PageLayout";
import { ErrorPage } from "../modules/error/ErrorPage";
import { Base } from "../modules/root/Base";

export enum ROUTES {
  Base = "/:id",
  JobDetails = ":id",
  ApplyLink = "apply",
}

export const router = createBrowserRouter([
  { path: "*", element: <Base />, errorElement: <ErrorPage /> },
  {
    path: ROUTES.Base,
    element: <RootLayout />,

    children: [
      { index: true, element: <HomePage />, errorElement: <ErrorPage /> },
      {
        path: ROUTES.JobDetails,
        element: <PageBaseLayout />,
        children: [{ index: true, element: <JobDetails /> }],
      },
    ],
  },
]);
